/**
 * Maps the duration labels used by Settings > Security Settings dropdowns
 * (Global Session Expiry / Auto-timeout Duration) to milliseconds.
 * Mirrors pulo_api's parseDurationToMs so both sides agree on what
 * "15 Minutes" etc. mean.
 */
export function parseDurationToMs(label) {
  switch (label) {
    case "15 Minutes":
      return 15 * 60 * 1000;
    case "30 Minutes":
      return 30 * 60 * 1000;
    case "1 Hour":
      return 60 * 60 * 1000;
    case "24 Hours":
      return 24 * 60 * 60 * 1000;
    default:
      return null;
  }
}

export default parseDurationToMs;
